import React from 'react';
import { showCustomDialog } from '../DialogHelper';
import { LogoutWarningContent } from './components';
import { useIdleTimeout } from './useIdleTimeout';
export function useIdleUserMonitor(params) {
    var _a;
    const WARNING_TIMEOUT_MS = 60 * 1000;
    useIdleTimeout({
        idleTimeoutMs: params.sessionTimeoutMs - ((_a = params.warningTimeoutMs) !== null && _a !== void 0 ? _a : WARNING_TIMEOUT_MS),
        debounceMs: params.sessionRefreshMs,
        monitorDelayMs: params.monitorDelayMs,
        onIdle: (idleForMs, onIdleCancel) => {
            showLogoutWarningDialog({
                onSessionRefresh: () => {
                    params.onSessionRefresh();
                    onIdleCancel();
                },
                idleForMs,
                onLoggedOutAcknowledge: params.onLoggedOutAcknowledge,
                onLogoutClick: params.onLogoutClick,
                sessionTimeoutMs: params.sessionTimeoutMs,
                onBeforeSessionExpiredDialogShow: params.onBeforeSessionExpiredDialogShow,
            });
        },
        onActive: () => params.onSessionRefresh(),
    });
}
function showLogoutWarningDialog(params) {
    showCustomDialog({
        content: (close) => (React.createElement(LogoutWarningContent, { onLoggedOutAcknowledge: () => {
                params.onLoggedOutAcknowledge();
                close();
            }, onSessionRefresh: () => {
                params.onSessionRefresh();
                close();
            }, onLogoutClick: () => {
                params.onLogoutClick();
                close();
            }, onBeforeSessionExpiredDialogShow: params.onBeforeSessionExpiredDialogShow, idleForMs: params.idleForMs, sessionTimeoutMs: params.sessionTimeoutMs })),
    });
}
